import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { ChevronLeft, Check } from 'lucide-react';
import ContactModal from '../components/ContactModal';
import { getImageUrl } from '../lib/api';
import '../styles/productDetail.css';

export default function ProductDetail({ product }) {
  const navigate = useNavigate();
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, []);

  if (!product) {
    return (
      <div className="product-detail-page">
        <Helmet>
          <title>Product Not Found - Sitcorp International</title>
        </Helmet>
        <div className="container">
          <div className="product-not-found">
            <h1>Product Not Found</h1>
            <p>The product you're looking for is not available.</p>
            <button className="btn-primary" onClick={() => navigate(-1)}>
              Go Back
            </button>
          </div>
        </div>
      </div>
    );
  }

  const productImageUrl = getImageUrl(product.images?.[0] || product.image, product.uploadedAt ? new Date(product.uploadedAt).getTime() : null);
  const productDescription = product.description || `High-quality ${product.name} manufactured by Sitcorp International`;

  return (
    <div className="product-detail-page">
      <Helmet>
        <title>{product.name} - Sitcorp International</title>
        <meta name="description" content={productDescription} />
        <link rel="canonical" href={`https://localhost:5000/product/${product._id}`} />
        <meta property="og:title" content={`${product.name} - Sitcorp International`} />
        <meta property="og:description" content={productDescription} />
        <meta property="og:image" content={productImageUrl} />
        <meta property="og:url" content={`https://localhost:5000/product/${product._id}`} />
        <meta property="og:type" content="product" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org/",
            "@type": "Product",
            "name": product.name,
            "description": productDescription,
            "image": productImageUrl,
            "brand": {
              "@type": "Brand",
              "name": "Sitcorp International"
            },
            "manufacturer": {
              "@type": "Organization",
              "name": "Sitcorp International"
            }
          })}
        </script>
      </Helmet>

      <div className="container">
        {/* <button className="back-button" onClick={() => navigate(-1)}>
          <ChevronLeft size={20} />
          Back
        </button> */}

        <div className="product-detail-wrapper">
          <div className="product-detail-grid">
            <div className="product-detail-image">
              <div className="image-container">
                <img
                  src={getImageUrl(product.image, product.uploadedAt ? new Date(product.uploadedAt).getTime() : null)}
                  alt={product.name}
                  loading="lazy"
                  decoding="async"
                />
              </div>
            </div>

            <div className="product-detail-content">
              <div className="product-header">
                {/* <span className="product-category">{product.category?.name || 'Uncategorized'}</span> */}
                <h1>{product.name}</h1>
              </div>

              <div className="product-section">
                <h3>Description</h3>
                <p className="product-main-description">{product.description}</p>
                <p className="product-extended-description">
                  Our {product.name.toLowerCase()} represents the perfect blend of quality craftsmanship
                  and modern design. Manufactured with premium materials and attention to detail, this product
                  meets the highest international standards. Perfect for businesses looking for reliable, 
                  sustainable sourcing and manufacturing solutions.
                </p>
              </div>

              <div className="product-actions">
                <button
                  className="btn-primary"
                  onClick={() => setIsContactModalOpen(true)}
                >
                  Contact Us for Quote
                </button>
                <button 
                  className="btn-secondary"
                  onClick={() => navigate(-1)}
                >
                  View More Products
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ContactModal
        isOpen={isContactModalOpen}
        onClose={() => setIsContactModalOpen(false)}
        productName={product.name}
      />
    </div>
  );
}
